import React from 'react';
import { awards } from '../data/mock';
import { Award, Star, Trophy, Medal } from 'lucide-react';

const iconMap = {
  '🏆': Trophy,
  '🥇': Medal,
  '🎖️': Award,
  '⭐': Star,
  '🏅': Medal,
};

const Awards = () => {
  return (
    <section className="py-24 bg-slate-950 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/20 mb-4">
            <Award className="w-4 h-4 text-cyan-400 mr-2" />
            <span className="text-cyan-400 text-sm font-medium">Awards & Recognition</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Our Awards
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Celebrating excellence and innovation. Our awards showcase trust, 
            dedication, and industry leadership.
          </p>
        </div>

        {/* Awards Carousel */}
        <div className="relative">
          <div className="flex animate-scroll">
            {[...awards, ...awards].map((award, index) => {
              const IconComponent = iconMap[award.icon] || Trophy;
              return (
                <div
                  key={`${award.id}-${index}`}
                  className="flex-shrink-0 w-72 mx-4"
                >
                  <div className="bg-gradient-to-br from-slate-800 to-slate-900 border border-slate-700 rounded-2xl p-8 h-full hover:border-cyan-500/50 transition-all duration-300 group">
                    <div className="w-16 h-16 bg-gradient-to-br from-cyan-500/20 to-blue-600/20 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                      <IconComponent className="w-8 h-8 text-cyan-400" />
                    </div>
                    <h3 className="text-white font-semibold text-lg mb-2">
                      {award.title}
                    </h3>
                    <p className="text-gray-400 text-sm mb-4">
                      {award.organization}
                    </p>
                    <div className="inline-flex items-center px-3 py-1 bg-cyan-500/10 rounded-full">
                      <span className="text-cyan-400 text-sm font-medium">
                        {award.year}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default Awards;
